export default __webpack_public_path__ + "static/media/particleListensSecondary.1c51b082.svg";